// src/utils.js

export const formatDuration = (seconds = 0) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hours > 0 ? `${hours} ժ ` : ''}${minutes > 0 ? `${minutes} ր ` : ''}${secs} վրկ`;
  };
  
  export const formatDate = (timestamp) => {
    const createdDate = timestamp.toDate();
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);
  
    const time = createdDate.toLocaleTimeString('hy-AM', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  
    if (
      createdDate.getDate() === today.getDate() &&
      createdDate.getMonth() === today.getMonth() &&
      createdDate.getFullYear() === today.getFullYear()
    ) {
      return `Այսօր ${time}`;
    } else if (
      createdDate.getDate() === yesterday.getDate() &&
      createdDate.getMonth() === yesterday.getMonth() &&
      createdDate.getFullYear() === yesterday.getFullYear()
    ) {
      return `Երեկ ${time}`;
    }
  
    const day = String(createdDate.getDate()).padStart(2, '0');
    const month = String(createdDate.getMonth() + 1).padStart(2, '0');
    const year = createdDate.getFullYear();
    return `${day}.${month}.${year} ${time}`;
  };

const SECONDS_PER_DAY = 24 * 3600;

export const parseTimeOfDayToSeconds = (str) => {
  if (typeof str !== 'string') return null;
  const trimmed = str.trim();
  if (!trimmed) return null;
  const parts = trimmed.split(':');
  if (parts.length < 2 || parts.length > 3) return null;
  const nums = parts.map((p) => Number(p));
  if (nums.some((n) => !Number.isFinite(n) || n < 0)) return null;
  const [h, m, s = 0] = nums;
  if (h > 23 || m > 59 || s >= 60) return null;
  return h * 3600 + m * 60 + Math.floor(s);
};

export const formatSecondsAsTimeOfDay = (totalSeconds) => {
  if (totalSeconds == null || !Number.isFinite(totalSeconds)) return '';
  const normalized = ((Math.floor(totalSeconds) % SECONDS_PER_DAY) + SECONDS_PER_DAY) % SECONDS_PER_DAY;
  const h = Math.floor(normalized / 3600);
  const m = Math.floor((normalized % 3600) / 60);
  const s = normalized % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
};

export const formatTranscriptTimestamp = (audioSeconds, offsetSeconds, opts = {}) => {
  if (audioSeconds == null || !Number.isFinite(audioSeconds)) {
    return opts.brackets === false ? '0:00' : '';
  }
  const brackets = opts.brackets !== false;

  if (offsetSeconds == null) {
    const safe = Math.max(0, audioSeconds);
    const h = Math.floor(safe / 3600);
    const m = Math.floor((safe % 3600) / 60);
    const s = Math.floor(safe % 60);
    if (brackets) {
      if (h > 0) {
        return `[${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}]`;
      }
      return `[${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}]`;
    }
    if (h > 0) {
      return `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
    }
    return `${m}:${String(s).padStart(2, '0')}`;
  }

  const wallClock = formatSecondsAsTimeOfDay(audioSeconds + offsetSeconds);
  return brackets ? `[${wallClock}]` : wallClock;
};
